// src/Modules/User/Presentation/reducers.ts
import { createSlice } from '@reduxjs/toolkit';
import { User } from '../Model/User';
import {
  activateSlotOpsOverrideThunk,
  clearExpiredSlotOpsOverrideThunk,
  fetchMeThunk,
  initAuthThunk,
  loginThunk,
  refreshTokenThunk,
} from './actions';
import { clearSlotOpsOverrideToken } from '../../../Utils/slotOpsOverride';

interface AuthState {
  user: User | null;
  access: string | null;
  refresh: string | null;
  loading: boolean;
}
const initialState: AuthState = { user: null, access: null, refresh: null, loading: false };

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.user = state.access = state.refresh = null;
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      clearSlotOpsOverrideToken();
    },
  },
  extraReducers: b => {
    /* login */
    b.addCase(loginThunk.pending, s => { s.loading = true; })
     .addCase(loginThunk.fulfilled, (s, a) => {
       s.loading  = false;
       s.user     = a.payload.user;
       s.access   = a.payload.tokens.access;
       s.refresh  = a.payload.tokens.refresh;
       localStorage.setItem('access',  s.access!);
       localStorage.setItem('refresh', s.refresh!);
     })
     .addCase(loginThunk.rejected, s => { s.loading = false; });

    /* init */
    b.addCase(initAuthThunk.fulfilled, (s, a) => {
      if (a.payload) {
        s.user    = a.payload.user;
        s.access  = a.payload.access;
        s.refresh = a.payload.refresh;
      }
    });

    /* refresh */
    b.addCase(refreshTokenThunk.fulfilled, (s, a) => {
      s.access = a.payload;
      localStorage.setItem('access', a.payload);
    });

    b.addCase(fetchMeThunk.fulfilled, (s, a) => {
      s.user = a.payload;
    });

    b.addCase(activateSlotOpsOverrideThunk.fulfilled, (s, a) => {
      s.user = a.payload.user;
    });

    b.addCase(clearExpiredSlotOpsOverrideThunk.fulfilled, (s, a) => {
      s.user = a.payload;
    });
  },
});

export const { logout } = slice.actions;
export default slice.reducer;
